import {Component} from '@angular/core';

@Component({
  selector: 'app-simple-layout',
  template: '<router-outlet></router-outlet>'
})
export class SimpleContainerComponent {
}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/layouts/simple-container/simple-container.component.ts